import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const CreacionTrasladoApi = () => {
    const [cargando, setCargando] = useState(false);

    const crearTraslado = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("prod_bodega_control_calidad", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getExistenciasDisponibles = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "prod_bodega_control_calidad/existencias_disponibles",
                params,
            );
            return response || { results: [] };
        } catch (error) {
            console.error(error);
            return { results: [] };
        } finally {
            setCargando(false);
        }
    };

    const getExistenciasSobranteDisponibles = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "prod_bodega_control_calidad/existencias_sobrante_disponibles",
                params,
            );
            return response || [];
        } catch (error) {
            console.error(error);
            return [];
        } finally {
            setCargando(false);
        }
    };

    const getPalletsIngresadosDespues = async (params) => {
        return api
            .get("prod_bodega_control_calidad/pallets_ingresados_despues", params)
            .then((data) => {
                if (data) return data.pallets;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        crearTraslado,
        getExistenciasDisponibles,
        getExistenciasSobranteDisponibles,
        getPalletsIngresadosDespues,

        cargando,
    };
};
